export enum HubSpotAuthType {
	/** Default - preserves backward compatibility for existing saved flows. */
	PrivateAppToken,
	WebApp,
}

export interface HubSpotConnectionDetails {
	authType?: HubSpotAuthType;
	/** PrivateAppToken auth only. */
	accessToken: string;
	/** PrivateAppToken auth only. */
	useVariableToken?: boolean;
	/** WebApp auth only - selected OAuthConnectionConfig.id (provider=HubSpot). */
	connectionID?: string;
	hubSpotObjectType: string;
}
